import script from "./recientesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./recientesForm.vue?vue&type=script&setup=true&lang=js"

import "./recientesForm.vue?vue&type=style&index=0&id=4a7ca508&scoped=true&lang=css"
import "./recientesForm.vue?vue&type=style&index=1&id=4a7ca508&lang=css"
import "./recientesForm.vue?vue&type=style&index=2&id=4a7ca508&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7ca508"]])

export default __exports__